import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ProfessionalStyleService } from '@adeo/ngx-kozikaza-api';
import { switchMap } from 'rxjs/operators';
import { getTranslation } from '../../../utils/const/translation';

@Injectable()
export class StyleMetasResolver  {

    constructor(
        private professionalStyleService: ProfessionalStyleService
    ) {
    }

    resolve(
        route: ActivatedRouteSnapshot
    ): Observable<any> {
        return this.professionalStyleService.getProfessionalStyles().pipe(
          switchMap((data) => {
            const styles = data['hydra:member'];

            if (route.params && route.params.styleSlug) {
              const style = styles.find((s) => s.nameSlug === route.params.styleSlug);
              route.data = {...route.data, ...{
                  style: style,
                  breadcrumbRedirect: 'style-' + style.nameSlug,
                  breadcrumb: getTranslation(route.data.breadcrumbKey, {styleName : style.name}),
                  metasOverride : { ...route.data.metas , ...{
                        title: getTranslation(route.data.metas.titleKey, {styleName : style.name}),
                        description: getTranslation(route.data.metas.descriptionKey, {styleName : style.name}),
                      }}
                }};
            }

            return of(styles);
          })
        );
    }
}
